import { useEffect, useState } from 'react';

import { SERVER_ORIGIN } from '../config';

// Landing page hit from the password-reset email link. Reads ?token=...
// from the URL, then asks for the new password. On success, clears history
// and bounces back to '/' for sign-in.
export function ResetPasswordPage() {
  const [token, setToken] = useState<string | null>(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get('token'));
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!token) { setError('Missing token.'); return; }
    if (newPassword.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match.'); return; }
    setBusy(true);
    try {
      const res = await fetch(`${SERVER_ORIGIN}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(j.error ?? 'Reset failed.');
        return;
      }
      setDone(true);
      setTimeout(() => {
        window.history.replaceState({}, '', '/');
        window.location.reload();
      }, 2000);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'network error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={pageStyle}>
      <h1 style={{ color: 'var(--accent-color)', marginBottom: 8, fontSize: '2.5rem' }}>GrandSnatch</h1>
      <h2 style={{ marginBottom: 24, fontSize: '1rem', color: '#aaa' }}>Reset your password</h2>
      <div style={{
        maxWidth: 360, padding: 20, background: '#15151f', border: '1px solid #2a2a3a',
        borderRadius: 6, width: '100%',
      }}>
        {!token ? (
          <div style={{ color: '#e57373', textAlign: 'center' }}>Missing reset token.</div>
        ) : done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>✓</div>
            <div style={{ color: '#4CAF50', fontWeight: 'bold', marginBottom: 6 }}>Password updated.</div>
            <div style={{ color: '#888', fontSize: 12 }}>Redirecting to sign in...</div>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <input
              type="password"
              placeholder="new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              autoFocus
              style={inputStyle}
              disabled={busy}
            />
            <input
              type="password"
              placeholder="confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              style={inputStyle}
              disabled={busy}
            />
            {error && <div style={{ color: '#e57373', fontSize: 12, textAlign: 'center' }}>{error}</div>}
            <button type="submit" className="multi-btn" disabled={busy || !newPassword || !confirmPassword}>
              {busy ? '...' : 'Update password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const pageStyle: React.CSSProperties = {
  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
  height: '100vh', background: 'var(--bg-color)', color: 'var(--text-color)',
};
const inputStyle: React.CSSProperties = {
  padding: '10px 12px',
  fontSize: '14px',
  fontFamily: 'inherit',
  background: '#1a1a24',
  border: '1px solid #444',
  borderRadius: '4px',
  color: 'var(--text-color)',
};
